var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTestreports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.042,
    height: 42,
    viewBox: "0 0 34.042 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "test-report",
    transform: "translate(-48.504 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M81.316,18.544H76.4V8.614a1.23,1.23,0,0,0-.36-.87C68.031-.26,68.472,0,67.785,0H49.734a1.231,1.231,0,0,0-1.23,1.23v37a1.231,1.231,0,0,0,1.23,1.23H72.083a4.921,4.921,0,0,0,9.229-2.379V21h0a1.23,1.23,0,0,0,0-2.461ZM69.015,4.2l3.264,3.264H69.015ZM50.965,2.462h15.59V8.7a1.23,1.23,0,0,0,1.23,1.23h6.152v8.617H71.472a1.23,1.23,0,0,0,0,2.461V37h-20.5ZM76.39,39.539a2.464,2.464,0,0,1-2.461-2.461V29.614h4.922v7.465a2.464,2.464,0,0,1-2.461,2.461Zm2.461-12.386H73.929V21h4.922Z",
    transform: "translate(0)",
    fill: "#f6781b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M109.783,123.469h8.2a1.23,1.23,0,1,0,0-2.461h-8.2a1.23,1.23,0,0,0,0,2.461Z",
    transform: "translate(-55.123 -111.082)",
    fill: "#0060a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M109.783,183.468H122.9a1.23,1.23,0,1,0,0-2.461H109.783a1.23,1.23,0,0,0,0,2.461Z",
    transform: "translate(-55.123 -166.159)",
    fill: "#0060a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M122.9,241.006H109.783a1.23,1.23,0,0,0,0,2.461H122.9a1.23,1.23,0,0,0,0-2.461Z",
    transform: "translate(-55.123 -221.236)",
    fill: "#0060a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M122.9,301.005H109.783a1.23,1.23,0,0,0,0,2.461H122.9a1.23,1.23,0,0,0,0-2.461Z",
    transform: "translate(-55.123 -276.313)",
    fill: "#0060a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M122.9,361H109.783a1.23,1.23,0,0,0,0,2.461H122.9a1.23,1.23,0,0,0,0-2.461Z",
    transform: "translate(-55.123 -331.39)",
    fill: "#0060a6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTestreports);
export default __webpack_public_path__ + "static/media/icon_testreports.38f23315524f0a84013b97a804725485.svg";
export { ForwardRef as ReactComponent };